import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../modal';
import './styles.scss';

const GlobalModal = ({ onAccept, title, body, ctaTitle }) => (
    <Modal
        visible
    >
        <div className="bs-globalModal">
            <span className="bs-globalModal__title">{title}</span>
            <span className="bs-globalModal__body">{body}</span>
            <button
                onClick={onAccept}
                className="bs-globalModal__button"
            >
                <span>{ctaTitle}</span>
            </button>
        </div>
    </Modal>
);

GlobalModal.defaultProps = {
    title: null,
    ctaTitle: 'OK',
};

GlobalModal.propTypes = {
    onAccept: PropTypes.func.isRequired,
    title: PropTypes.string,
    ctaTitle: PropTypes.string,
    body: PropTypes.string.isRequired,
};

export default GlobalModal;



// WEBPACK FOOTER //
// /src/js/common/globalModal/GlobalModal.jsx